import RolesStore from '../Stores/Roles'

export default function useMyHome ()
{
	const my_home = RolesStore.useState(s => s.home || '/');

	return my_home;
}